module.exports = "/_next/static/public/images/spinner-18e30e1e04a2ac7c95ca57166fb55748.gif";